<div class="group3">
  <h4 *ngIf="!hidetitle"> Info. Part. </h4>
  <!-- <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt129">
    <label class="col-sm-3 champ" style="padding:0px">Prix Négociés :</label>
    <div class="col-sm-9 champ text-underline historique" style="padding-right: 0px" [ngClass]="{'disabledbutton': add}"
      (click)="showPrixNego()">
      Afficher
    </div>
  </div> -->

  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt134 && common.visibleChamp.cltObj134.visible">
    <label class="col-sm-3 champ" style="padding:0px">Véhicule :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{(detail.vehicule || '') | maskInput: !common.visibleChamp.cltObj134.vision}}</div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.vehicule" maskPass
        [visible]="common.visibleChamp.cltObj134.vision"
        [disabled]="(add && !common.visibleChamp.cltObj134.creation) || (!add && edit && !common.visibleChamp.cltObj134.modifiable)">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt135 && common.visibleChamp.cltObj135.visible">
    <label class="col-sm-3 champ" style="padding:0px"> Nature pièce :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div
        [ngClass]="{'disabledbutton': !edit || (add && !common.visibleChamp.cltObj135.creation) || (!add && edit && !common.visibleChamp.cltObj135.modifiable)}">
        <app-autocomplete *ngIf="common.visibleChamp.cltObj135.vision"
          (selectfunction)="detail.typeIdentite = $event.libelleObjetEntite;" [results]="listNature" [highlight]="true"
          [id]="'modedepaie'" [isCombo]="true" [defaultselected]="detail.typeIdentite" [disablefocus]="true"
          [defaultsearch]="detail.typeIdentite || ''">
        </app-autocomplete>
      </div>
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt136 && common.visibleChamp.cltObj136.visible">
    <label class="col-sm-3 champ" style="padding:0px">N° pièce :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{(detail.identite || '') | maskInput: !common.visibleChamp.cltObj136.vision }}</div>
      <input *ngIf="edit" type="text" class="form-control" [(ngModel)]="detail.identite" maskPass
        [visible]="common.visibleChamp.cltObj136.vision"
        [disabled]="(add && !common.visibleChamp.cltObj136.creation) || (!add && edit && !common.visibleChamp.cltObj136.modifiable)">
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt137 && common.visibleChamp.cltObj137.visible">
    <label class="col-sm-3 champ" style="padding:0px">Date émission
      <span class="champobligatoire"> * </span> : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{(detail.dateIdentite || '') | maskInput: !common.visibleChamp.cltObj137.vision}}</div>
  
        <div *ngIf="edit" [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj137.creation) || (!add && edit && !common.visibleChamp.cltObj137.modifiable)}">
          <app-input-date [class]="'form-control'" [id]="'date'" [model]="detail.dateIdentiteModel"
          *ngIf ="common.visibleChamp.cltObj137.vision" [dateVide] = "true"
            (changefct)="detail.dateIdentiteModel = $event; changeDateN($event, 'dateIdentite'); showDate = true"
            [placeholder]="'Date émission'" (keyenterfct)="common.changeDate($event, detail.dateIdentiteModel, '#dateF');"
            [showDatepicker]="true" [closeDatepickerOnSelect]="true">
          </app-input-date>
        </div>

    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt138 && common.visibleChamp.cltObj138.visible">
    <label class="col-sm-3 champ" style="padding:0px">Date validité
      <span class="champobligatoire"> * </span> : </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{(detail.dateValiditeIdentite || '')| maskInput: !common.visibleChamp.cltObj138.vision}}</div>
         <div *ngIf="edit" [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj138.creation) || (!add && edit && !common.visibleChamp.cltObj138.modifiable)}">
           <app-input-date [class]="'form-control'" [id]="'date'" [model]="detail.dateValiditeIdentiteModel"
           *ngIf ="common.visibleChamp.cltObj138.vision" [dateVide] = "true"
             (changefct)="detail.dateValiditeIdentiteModel = $event; changeDateN($event, 'dateValiditeIdentite'); showDate = true"
             [placeholder]="'Date validité'" (keyenterfct)="common.changeDate($event, detail.dateValiditeIdentiteModel, '#dateF');"
             [showDatepicker]="true" [closeDatepickerOnSelect]="true">
           </app-input-date>
         </div>
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt139 && common.visibleChamp.cltObj139.visible">
    <label class="col-sm-3 champ" style="padding:0px"> Autorité :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div
        [ngClass]="{'disabledbutton': !edit || (add && !common.visibleChamp.cltObj139.creation) || (!add && edit && !common.visibleChamp.cltObj139.modifiable)}">
        <app-autocomplete *ngIf="common.visibleChamp.cltObj139.vision"
          (selectfunction)="objAutorite = $event; detail.autoriteIdentite = $event.id;" [results]="listAutorite"
          [highlight]="true" [id]="'modedepaie'" [defaultselected]="objAutorite" [disablefocus]="true"
          [selectvalue]="true"[activeVisibleChamp]="true" [visibleChamp]="common.visibleChamp.cltObj139.vision"
          [defaultsearch]="objAutorite ? (objAutorite.libelleObjetEntite || detail.autoriteIdentite || '') : ''"
          (searchfunction)="changeChampRecherche($event, 'autoriteIdentite')" [showonclick]="true">
        </app-autocomplete>
      </div>
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt141 && common.visibleChamp.cltObj141.visible">
    <label class="col-sm-3 champ" style="padding:0px">
      Lieu de naissance :
    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{(detail.lieuNaissance)| maskInput: !common.visibleChamp.cltObj141.vision}} </div>
      <div *ngIf="edit"
        [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj141.creation) || (!add && edit && !common.visibleChamp.cltObj141.modifiable)}">
        <app-autocomplete-cp-ville *ngIf="common.visibleChamp.cltObj141.vision" [cp]="'depNaissance'" [item]="detail"
          [ville]="'lieuNaissance'" [activeVisibleChamp]="true" [visibleChamp]="common.visibleChamp.cltObj141.vision">
        </app-autocomplete-cp-ville>
      </div>
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt159 && common.visibleChamp.cltObj159.visible">
    <label class="col-sm-3 champ" style="padding:0px">
      Dep de naissance :
    </label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit"> {{(detail.depNaissance)| maskInput: !common.visibleChamp.cltObj159.vision}} </div>
      <div *ngIf="edit"
        [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj159.creation) || (!add && edit && !common.visibleChamp.cltObj159.modifiable)}">
        <app-autocomplete-cp-ville *ngIf="common.visibleChamp.cltObj159.vision" [cp]="'depNaissance'" [item]="detail"
          [ville]="'lieuNaissance'" [iscp]="true" [activeVisibleChamp]="true"
          [visibleChamp]="common.visibleChamp.cltObj159.vision">
        </app-autocomplete-cp-ville>
      </div>
    </div>
  </div>

  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt142 && common.visibleChamp.cltObj142.visible">
    <label class="col-sm-3 champ" style="padding:0px">Date de naissance :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <div *ngIf="!edit">{{(detail.dateNaissance  || '')| maskInput: !common.visibleChamp.cltObj142.vision}}</div>
      <div *ngIf="edit"
        [ngClass]="{'disabledbutton': (add && !common.visibleChamp.cltObj142.creation) || (!add && edit && !common.visibleChamp.cltObj142.modifiable)}">
        <app-input-date [class]="'form-control'" [id]="'date'" [model]="detail.dateNaissanceModel"
        *ngIf ="common.visibleChamp.cltObj142.vision" [dateVide] = "true"
          (changefct)="detail.dateNaissanceModel = $event; changeDateN($event, 'dateNaissance'); showDate = true"
          [placeholder]="'Date de naissance'" (keyenterfct)="common.changeDate($event, detail.dateNaissanceModel, '#dateF');"
          [showDatepicker]="true" [closeDatepickerOnSelect]="true">
        </app-input-date>
      </div>
    </div>
  </div>
  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt143 && common.visibleChamp.cltObj143.visible">
    <label class="col-sm-3 champ" style="padding:0px">Montant annuel :</label>
    <div class="col-sm-9 champ" style="padding-right: 0px">
      <input type="number" class="form-control" readonly maskPass [visible]="common.visibleChamp.cltObj143.vision"
        [(ngModel)]="montant">
      {{common.visibleChamp.cltObj143.vision ? '' : '***'}}
    </div>
  </div>


  <div class="form-group items col-sm-12" *ngIf="common.visibleChamp.clt67 && common.visibleChamp.cltObj67.visible">
    <label class="col-sm-3 champ" style="padding:0px"> IBAN+BIC :</label>
    <div class="col-sm-9 champ text-underline historique" style="padding-right: 0px"
      *ngIf="common.visibleChamp.cltObj67.vision"
      [ngClass]="{'disabledbutton': !edit || (add && !common.visibleChamp.cltObj67.creation) || (!add && edit && !common.visibleChamp.cltObj67.modifiable)}"
      (click)="showIBANBIC()">
      Afficher
    </div>
  </div>


</div>



<ng-template #msg>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg" [innerHTML]="error" style="white-space: pre-line;     font-family: Roboto-Black;
        font-size: 14px;"> </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-mdp" (click)="common.closeModal()">
        Fermer </button>
    </div>
  </div>
</ng-template>